import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '~/App.tsx';

// antd v5 DatePicker는 dayjs.weekday()/localeData()를 사용한다.
// plugin 미등록 시 DatePicker 열기 단계에서 TypeError 발생.
dayjs.extend(weekday);
dayjs.extend(localeData);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
